document.addEventListener('DOMContentLoaded', function() {
  const kpoSticky = document.getElementById('kpo-sticky');
  const kpoModal = document.getElementById('kpo-modal');
  const kpoModalClose = document.querySelector('.kpo-modal__close');
  const kpoModalOverlay = document.querySelector('.kpo-modal__overlay');

  if (!kpoSticky || !kpoModal) return;

  let ticking = false;

  // Scroll fade effect
  function updateKpoOpacity() {
    const viewportHeight = window.innerHeight;
    const scrollAmount = window.scrollY;

    // Start fading out after scrolling about one screen height
    if (scrollAmount > viewportHeight) {
      const fadeAmount = (scrollAmount - viewportHeight) / viewportHeight; // 0 to 1
      const opacity = Math.max(0, 1 - fadeAmount);
      kpoSticky.style.opacity = opacity;

      if (opacity <= 0) {
        kpoSticky.classList.add('fade-out');
      } else {
        kpoSticky.classList.remove('fade-out');
      }
    } else {
      kpoSticky.style.opacity = 1;
      kpoSticky.classList.remove('fade-out');
    }

    ticking = false;
  }

  window.addEventListener('scroll', function() {
    if (!ticking) {
      window.requestAnimationFrame(updateKpoOpacity);
      ticking = true;
    }
  });

  // Modal functionality
  function openModal() {
    kpoModal.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    kpoModal.classList.remove('active');
    document.body.style.overflow = '';
  }

  // Open modal on KPO banner click
  kpoSticky.addEventListener('click', openModal);

  // Close modal on close button click
  if (kpoModalClose) {
    kpoModalClose.addEventListener('click', closeModal);
  }

  // Close modal on overlay click
  if (kpoModalOverlay) {
    kpoModalOverlay.addEventListener('click', closeModal);
  }

  // Close modal on ESC key
  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape' && kpoModal.classList.contains('active')) {
      closeModal();
    }
  });
});
